module.exports = __webpack_public_path__ + "img/avatar-s-11.ce1e3447.png";